import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  alertIcon: {
    alignSelf: 'center',
    height: Theme.px(88),
    width: Theme.px(99),
  },
  gradientWrapper: {
    borderRadius: Theme.tileBorderRadius,
    overflow: 'hidden',
  },
  wrapper: {
    height: Theme.px(546),
    justifyContent: 'center',
    width: Theme.px(674),
  },
  hideDisplay: {
    display: 'none',
  },
});
